import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { KeycloakService, KeycloakAuthGuard } from 'keycloak-angular';
import { KeycloakLoginOptions } from 'keycloak-js'; //SG-6764
import { Location } from '@angular/common'; //SG-6764
import { UserData } from './shared/service/UserService';
import { HelperService } from './modules/shared/services/helper.service';
@Injectable()
export class AppAuthGuard extends KeycloakAuthGuard {
  constructor(protected router: Router, 
    protected keycloakAngular: KeycloakService, 
    private location: Location,
    private helperService : HelperService// SG-8399
  ) {
    super(router, keycloakAngular);
  } //SG-6764

  // start SG-6764
  isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      //start SG-8399
      // Mobile device authenticated bypass Keycloak entirely
      const isMobileDevice = this.helperService.getIsMobileDevice();
      if (isMobileDevice) {
        return resolve(true);
      }
      //end SG-8399
      const authenticated = await this.keycloakAngular.isLoggedIn(); //SG-6764
      console.log("Authenticated - ", authenticated);
      if (!authenticated) {
        this.keycloakAngular.login();
        return;
      }

      const requiredRoles = route.data.roles;
      if (!requiredRoles || requiredRoles.length === 0) {
        return resolve(true);
      } else {
        if (!this.roles || this.roles.length === 0) {
          resolve(false);
        }
        let granted: boolean = false;
        for (const requiredRole of requiredRoles) {
          if (this.roles.indexOf(requiredRole) > -1) {
            granted = true;
            break;
          }
        }
        resolve(granted);
      }
    });
  }
  // end SG-6764
}
